import React from 'react';
import { Badge } from '../../../../../ui';
import type { BadgeTone } from '../../../../../ui';

/**
 * Status strings used by the teacher screens that src/ui's StatusBadge map doesn't know yet.
 * Merge into src/ui/components/Badge.tsx STATUS_TONES when promoting.
 */
export const TEACHER_STATUS_TONES: Record<string, BadgeTone> = {
  // shared with src/ui StatusBadge
  pending: 'warning',
  approved: 'success',
  success: 'success',
  successful: 'success',
  completed: 'success',
  complete: 'success',
  active: 'success',
  rejected: 'danger',
  failed: 'danger',
  cancelled: 'neutral',
  canceled: 'neutral',
  expired: 'neutral',
  draft: 'neutral',
  processing: 'info',
  scheduled: 'info',
  // teacher screens
  present: 'success',
  attended: 'success',
  marked: 'success',
  done: 'success',
  pass: 'success',
  passed: 'success',
  yes: 'success',
  true: 'success',
  booked: 'info',
  upcoming: 'info',
  rescheduled: 'info',
  'in progress': 'info',
  available: 'success',
  open: 'success',
  absent: 'danger',
  'no show': 'danger',
  noshow: 'danger',
  'teacher no show': 'danger',
  'student no show': 'warning',
  fail: 'danger',
  failed_qa: 'danger',
  no: 'danger',
  false: 'neutral',
  blocked: 'neutral',
  inactive: 'neutral',
  closed: 'neutral',
  leave: 'warning',
  'on leave': 'warning',
  'not marked': 'warning',
  unmarked: 'warning',
  review: 'warning',
  'under review': 'warning',
};

interface TeacherStatusBadgeProps {
  status?: string | null;
  label?: React.ReactNode;
  /** Page-local additions; prefer adding to TEACHER_STATUS_TONES. */
  tones?: Record<string, BadgeTone>;
  solid?: boolean;
}

const TeacherStatusBadge: React.FC<TeacherStatusBadgeProps> = ({ status, label, tones, solid }) => {
  const key = String(status ?? '').trim().toLowerCase();
  const tone = tones?.[key] ?? TEACHER_STATUS_TONES[key] ?? 'neutral';
  return (
    <Badge tone={tone} solid={solid}>
      {label ?? (key || 'unknown')}
    </Badge>
  );
};

export default TeacherStatusBadge;
